import type { QueryClient } from "@tanstack/react-query";

const FINANCIAL_QUERY_KEYS = [
  "transactions",
  "billableTransactions",
  "repeatedTransactions",
  "monthlyBalances",
  "accountsBalance",
  "categoriesBalance",
  "budgetBalance",
  "installments",
  "installmentsBalance",
  "savings",
  "savingsFunds",
  "tagsBalance",
] as const;

export const invalidateFinancialData = (queryClient: QueryClient) =>
  Promise.all(
    FINANCIAL_QUERY_KEYS.map((key) => queryClient.invalidateQueries({ queryKey: [key] })),
  );
